export default __webpack_public_path__ + "static/media/selfService.ef2408e4.svg";